import { action, observable } from 'mobx';
import { FormulaFormVM } from '../template/FormulaFormVM';
import { WeirFlowRequest, WeirFlowResponseDto } from 'cd-eft/_codegen_/openapi-generator/eft-set';
import { HydraulicFormulaController } from 'cd-eft/services/eftSetApi';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
interface IweirflowForm {
  weirCoefficient: string;
  lengthOfWeir: string;
  headOnWeir: string;
}

interface IEntrySelectInterface {
  name: string;
  value: string;
}


export class weirflowVM extends FormulaFormVM {
  readonly formLabelsForExport;
  readonly resultLabelsForExport;
  constructor(props) {
    super(props); //optional
    this.helpLink =
      'https://usdagcc.sharepoint.com/:b:/r/sites/FPAC-NRCS-EngineeringPlanningAnalysisandDesignSoftwareEPAD/Shared%20Documents/General/NETS-Support%20Documents/Formulas%20Documentation/Help%20Select%20n%20Value.pdf?csf=1&web=1&e=ssYi6q';
    this.formLabelsForExport = {
      weirCoefficient: 'Weir Coefficient (C)',
      lengthOfWeir: 'Length of Weir (ft)',
      headOnWeir: 'Head on Weir (in)',
    };
    this.resultLabelsForExport = {
      q: 'Flow Q (cfs)', 
    };
  }

  @observable weirFlowResults: WeirFlowResponseDto = {
    q: 0,
  };

  @observable savedweirflowFormData!: IweirflowForm;

  @observable weirflowFormData: IweirflowForm = {
    weirCoefficient: '',
    lengthOfWeir: "0",
    headOnWeir: "0",
  };

  @observable entryOptions: IEntrySelectInterface[] = [];

  @observable formValidation = {
    hasError: true,
    weirCoefficient: false,
    lengthOfWeir: false,
    headOnWeir: false,
    formErrors: {
      weirCoefficient: '',
      lengthOfWeir: '',
      headOnWeir: '',
    },
  };

  @action.bound weirflowErrorClass(field) {
    const errorMessage = this.formValidation.formErrors[field];
    return errorMessage?.length === 0 ? '' : ' usa-input--error';
  }


  @action.bound handleOnKeyDown(event) {
    ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault();
  }

  @action.bound handleWeirFlowForm(event,within?:boolean) {
    const { name } = event.target;
    let value = event.target.value;
    if (!within && name !== 'weir-coefficient' && value.length > 7) {
      return;
    }

    switch (name) {
      case 'weir-coefficient':
        this.weirflowFormData.weirCoefficient = value;
        break;
      case 'length-of-weir':
        this.weirflowFormData.lengthOfWeir = value;
        break;
      case 'head-on-weir':
        this.weirflowFormData.headOnWeir = value;
        break;
    }
  }

  @action.bound async handleInputOnBlur(name, value) {
    let inputValue: number | string = value;

    if (name !== 'weir-coefficient') {
      inputValue = parseFloat(value); 
      if (isNaN(inputValue) || value === '') {
        inputValue = ''; 
      } else {
        inputValue = this.roundingHelperNumber(inputValue, 2); 
      }
    }
    const event ={ 
      target:{ 
        name: name, 
        value: inputValue 
      }
    }

    this.handleWeirFlowForm(event);

    await this.validateInput(name, inputValue);
  }
 @action.bound setFixedValue(name, fixed) {
    const event1 = {
     target: {
     name: name,
     value: this.roundingHelperString(fixed, 2)
     }
     }
    this.handleWeirFlowForm(event1, true);
     }
  @action.bound async validateInput(name, value) {
    const val = this.roundingHelperNumber(parseFloat(value), 2);
    if (name !== "weir-coefficient" && value !== undefined && value !== '') this.setFixedValue(name, val);
    switch (name) {
      case 'weir-coefficient':
        if (value === '' || value === undefined) {
          this.formValidation.weirCoefficient = true;
          this.formValidation.formErrors.weirCoefficient = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_09', undefined, this.formLabelsForExport.weirCoefficient.replace(/(\s\([\w\W]*\))/, ''))
        } else {
          this.formValidation.weirCoefficient = false;
          this.formValidation.formErrors.weirCoefficient = '';
          this.formValidation.hasError = false;
          this.weirflowFormData.weirCoefficient = value;
        }
        break;
      case 'length-of-weir':
        if (value === '' || val <= 0) {
          this.formValidation.lengthOfWeir = true;
          this.formValidation.formErrors.lengthOfWeir = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.lengthOfWeir.replace(/(\s\([\w\W]*\))/, ''));
        } else {
          this.formValidation.lengthOfWeir = false;
          this.formValidation.formErrors.lengthOfWeir = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'head-on-weir':
        if (value === '' || val <= 0) {
          this.formValidation.headOnWeir = true;
          this.formValidation.formErrors.headOnWeir = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.headOnWeir.replace(/(\s\([\w\W]*\))/, ''));
        } else {
          this.formValidation.headOnWeir = false;
          this.formValidation.formErrors.headOnWeir = '';
          this.formValidation.hasError = false;
        }
        break;
    }
  }


  get validateRequiredInputs() {
    if (
      this.formValidation.weirCoefficient ||
      this.formValidation.headOnWeir ||
      this.formValidation.lengthOfWeir
    ) {
      return false;
    }
    else {
      return true;
    }
  }

  async validateReqInput() {
    await this.validateInput('weir-coefficient', this.weirflowFormData.weirCoefficient);
    await this.validateInput('length-of-weir', this.weirflowFormData.lengthOfWeir);
    await this.validateInput('head-on-weir', this.weirflowFormData.headOnWeir);
  }

  @action.bound async computeweirflow() {
    this.disableComputeBtn = true;
    this.disablePrintBtn = true;
    const requestPayload: WeirFlowRequest = {
      weirCoefficient: this.weirflowFormData.weirCoefficient,
      headOfWeir: parseFloat(this.weirflowFormData.headOnWeir),
      lengthOfWeir: parseFloat(this.weirflowFormData.lengthOfWeir),
    };
    MessageCenter.blockCalls(['Common_26']);
    await this.validateReqInput();
    if (this.validateRequiredInputs) {
      try {

        const response = await HydraulicFormulaController.calculateWeirFlowUsingPOST(requestPayload);
        const shortCode = response?.data?.errorResponse?.errorCode?.replace(/[123]_[a-zA-Z]+_[a-zA-Z]+_/, '');
        if (response && response.data) {
          if (response.data.validationPass) {
            this.hasResults = true;
            this.disablePrintBtn = false;
            this.weirFlowResults = response.data;
            this.savedweirflowFormData = { ...this.weirflowFormData };
          } else if (
            response?.data?.errorResponse?.errorMessage != undefined &&
            response?.data?.errorResponse?.errorType != undefined
          ) {
            MessageCenter.addNotification(
              response?.data?.errorResponse?.errorMessage,
              response?.data?.errorResponse?.errorType,
              shortCode
            );
            this.disablePrintBtn = true;
            this.hasResults = false;
          }
        }
      } catch (error) {
        this.hasResults = false;
        this.disablePrintBtn = true;
        console.error(error);
      }
    } else {
      MessageCenter.resetMessageCenter();
      await MessageCenter.addNotificationFromCode('Common_26');
      this.hasResults = false;
      this.disablePrintBtn = true;
    }
    this.disableComputeBtn = false;
    MessageCenter.unblockCalls();
  }

  @action.bound launchAndExport() {
    // disable print button
    this.disablePrintBtn = true;
    this.exportedInputs = [];
    this.exportedResults = [];

    for (const input in this.savedweirflowFormData) {
      this.exportedInputs.push({
        label: this.formLabelsForExport[input],
        value: this.savedweirflowFormData[input],
      });
    }
    for (const result in this.weirFlowResults) {
      if (result !== 'errorResponse' || 'validationPass') {
        const label = this.resultLabelsForExport[result];
        const value = this.weirFlowResults[result];
        if (label && value !== undefined) {
          this.exportedResults.push({
            label: this.resultLabelsForExport[result],
            value: this.weirFlowResults[result]
          });
        }
      }
    }
    this.printFormula();
    this.disablePrintBtn = false;
  }

  @action.bound printweirflow() { }

  @action.bound initializeDefaultValues(): void {
    this.weirflowFormData = {
      weirCoefficient: '',
      lengthOfWeir: this.roundingHelperString(this.defaultValues.lengthOfWeir, 2),
      headOnWeir: this.roundingHelperString(this.defaultValues.headOfWeir, 2),
    };
    this.savedweirflowFormData = { ...this.weirflowFormData };
    this.entryOptions = [];
    this.entryOptions = (this.defaultValues.weirCoefficient as string[]).map((value, index) => ({
      value: value,
      name: value,
    }));
    this.weirflowFormData.weirCoefficient = this.entryOptions[0].value;
    this.weirflowFormData.weirCoefficient = ""; 
  }
}
